import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box } from 'braid-design-system';

import useACL from '../../../../../../../hooks/useACL';
import useAppConfig from '../../../../../../../hooks/useAppConfig';

import { selectors as routerSelectors } from '../../../../../../../store/router';
import { selectors as balanceSelectors } from '../../../../../../../store/balance';
import { selectors as userSelectors } from '../../../../../../../store/user';

import MenuLink from '../MenuLink/MenuLink';
import { getPageLinks } from './../../PageLinks/getPageLinks';

import * as styles from './PageLinks.css';
import { useTranslations } from '@vocab/react';
import translations from '../../PageLinks/.vocab';
import { useConstantUrls } from 'src/hooks/useConstUrls/useConstantUrls';
import { useRoutes } from 'src/hooks/useRoutes';
interface Props {
  onSelect: () => void;
}

const PageLinks = ({ onSelect }: Props) => {
  const { getProductConfig, getProductType } = useACL();
  const { routes } = useRoutes();
  const { COUNTRY_CODE: countryCode, IS_LEGACY_SITE: isLegacySite } =
    useAppConfig();

  const advertiserId = useSelector(userSelectors.getAdvertiserIdSelector);
  const creditBalance = useSelector(balanceSelectors.getCreditBalanceSelector);
  const jobId = useSelector(routerSelectors.getActiveJobIdSelector);
  const { t } = useTranslations(translations);
  const { creditDashboardUrl } = useConstantUrls();
  const pageLinks = getPageLinks(
    getProductConfig().links,
    {
      creditDashboardUrl,
      advertiserId,
      jobId,
      creditBalance,
      countryCode,
      isLegacySite,
      productType: getProductType(),
      t,
    },
    routes,
  );

  return useMemo(
    () => (
      <Box className={styles.container}>
        {pageLinks.map(
          (
            {
              href,
              hasCreditsMetricsEvent,
              isExternal,
              isActive,
              children,
              hasCredits,
            },
            index,
          ) => (
            <Box className={`${hasCredits ? styles.lastItem : ''}`} key={index}>
              <MenuLink
                key={index}
                href={href}
                hasCreditsMetricsEvent={hasCreditsMetricsEvent}
                isExternal={isExternal}
                isActive={isActive}
                isLast={hasCredits}
                onClick={onSelect}
              >
                <Box
                  className={styles.containerWithBorder}
                  display="flex"
                  alignItems="center"
                >
                  {children}
                </Box>
              </MenuLink>
            </Box>
          ),
        )}
      </Box>
    ),
    [pageLinks, onSelect],
  );
};

export default PageLinks;
